export const ru_policies = {
  refund: {
    title: "Политика возврата",
    backToCheckout: "Назад к оформлению",
    backToHome: "Вернуться на главную",
    setupFeeNotice: "Плата за установку в размере €500 не возвращается после начала разработки.",
    subscriptionNotice: "Платежи по подписке не возвращаются за оплаченные периоды.",
    exceptionalCircumstances: "Исключительные обстоятельства",
    exceptionalText: "Dathent оставляет за собой право принятия решений в исключительных обстоятельствах.",
    processTitle: "Процесс возврата",
    processText: "Если вы считаете, что у вас есть основания для исключения из политики возврата, пожалуйста, свяжитесь с нами:",
    earlyTerminationTitle: "Досрочное расторжение",
    earlyTerminationText: "Для получения информации о досрочном расторжении договора по модели Infrastructure Commitment, пожалуйста, обратитесь к",
    termsLink: "Условиям предоставления услуг",
    lastUpdated: "Последнее обновление: Февраль 2026"
  },
  privacy: {
    title: "Политика конфиденциальности",
    backToCheckout: "Назад к оформлению",
    backToHome: "Вернуться на главную",
    dataControllerTitle: "Контролер данных",
    companyName: "DATHENT SAX S.L.",
    nif: "NIF B22632632",
    address1: "Avenida Reyes Católicos 9, Bajo",
    address2: "03630 Sax (Alicante), Spain",
    dataCollectedTitle: "Собираемые данные",
    dataCollectedText: "Мы собираем и обрабатываем следующие категории персональных данных:",
    contactDetails: "Контактные данные (имя, email, телефон)",
    projectInfo: "Информация о проекте",
    commHistory: "История общения",
    purposeTitle: "Цель",
    purposeText: "Данные обрабатываются исключительно для:",
    serviceDelivery: "Оказания услуг",
    clientComm: "Общения с клиентами",
    paymentProcessing: "Обработки платежей",
    operationalImprovement: "Улучшения работы",
    paymentSecurityTitle: "Безопасность платежей",
    paymentSecurityText1: "Платежи обрабатываются через",
    paymentSecurityText2: "Dathent не хранит информацию о платежных картах.",
    dataRightsTitle: "Права на данные",
    dataRightsText: "В соответствии с GDPR клиенты могут запросить:",
    accessRight: "Доступ к своим персональным данным",
    rectificationRight: "Исправление неточных данных",
    erasureRight: "Удаление персональных данных",
    restrictionRight: "Ограничение обработки",
    requestsLabel: "Запросы:",
    dataRetentionTitle: "Хранение данных",
    dataRetentionText: "Персональные данные хранятся только столько времени, сколько необходимо для целей, изложенных выше, или в соответствии с требованиями законодательства.",
    thirdPartySharingTitle: "Передача данных третьим лицам",
    thirdPartySharingText: "Мы не продаем и не передаем персональные данные третьим лицам, за исключением случаев, необходимых для предоставления услуг (например, обработка платежей через Stripe).",
    contactTitle: "Контакты",
    contactText: "По всем вопросам, связанным с конфиденциальностью, обращайтесь:",
    lastUpdated: "Последнее обновление: Февраль 2026"
  },
  terms: {
    title: "Условия предоставления услуг",
    backToCheckout: "Назад к оформлению",
    backToHome: "Вернуться на главную",
    companyTitle: "1. Компания",
    companyText: "Этот веб-сайт и связанные услуги управляются:",
    companyName: "DATHENT SAX S.L.",
    cif: "CIF B22632632",
    address1: "Avenida Reyes Católicos 9, Bajo",
    address2: "03630 Sax (Alicante), Spain",
    companyNote: "Услуги предоставляются в соответствии с испанским законодательством и зарегистрированы в Торговом реестре Аликанте.",
    companyDesc: "Dathent предоставляет структурированные решения веб-инфраструктуры и долгосрочной технической поддержки для бизнеса.",
    serviceModelsTitle: "2. Модели обслуживания",
    serviceModelsText: "Dathent предлагает две коммерческие модели:",
    fullDevTitle: "A. Модель полной разработки",
    fullDevPrice: "Единовременный платеж: €1500",
    fullDevNoSubscription: "Без обязательства подписки.",
    fullDevDesc: "Эта модель включает полную доставку веб-сайта без обязательства долгосрочной поддержки.",
    infraCommitTitle: "B. Модель инфраструктурного обязательства",
    infraSetup: "Начальная настройка: €500",
    infraSupport: "Текущая поддержка инфраструктуры: €50 в месяц",
    infraMinimum: "Минимальное обязательство: 12 месяцев",
    infraDesc: "Эта модель предоставляет сниженную цену разработки в обмен на структурированное соглашение о долгосрочной поддержке.",
    infraNote: "Стандартная ставка поддержки составляет €150 в месяц. Ставка €50 является договорным стимулом, связанным с 12-месячным обязательством.",
    commercialStructureTitle: "3. Коммерческая структура",
    commercialPoint1: "Сниженная плата за разработку (€500) не является отдельным продуктом.",
    commercialPoint2: "Она является частью структурированного соглашения об инфраструктуре.",
    commercialPoint3: "Экономическая стоимость разработки остается €1500.",
    commercialPoint4: "Сниженная входная цена предоставляется в связи с 12-месячным обязательством.",
    earlyTerminationTitle: "4. Досрочное расторжение",
    earlyTerminationText: "Если клиент расторгает соглашение о поддержке до завершения 12 месяцев, оставшаяся экономическая стоимость подлежит оплате.",
    calculationTitle: "Расчет:",
    fullDevValue: "Полная стоимость разработки: €1500",
    paidAtSetup: "Сумма, уплаченная при установке: €500",
    outstandingBalance: "Остаток к оплате: €1000",
    settlementNote: "После погашения этого остатка соглашение о поддержке прекращается, и дальнейшие ежемесячные платежи не применяются.",
    deliveryFrameworkTitle: "5. Рамки доставки",
    deliveryText: "Разработка начинается после подтверждения оплаты и получения необходимых материалов.",
    deliveryTime: "Типичное время доставки: от 1 недели.",
    acceleratedDelivery: "Ускоренная доставка может быть возможна в зависимости от объема проекта.",
    timelinesDepend: "Сроки зависят от оперативности клиента и сложности проекта.",
    intellectualPropertyTitle: "6. Интеллектуальная собственность",
    ipText: "Полное право собственности на разработанный веб-сайт передается после выполнения экономических обязательств в соответствии с одним из следующих вариантов:",
    ip12Months: "12-месячное инфраструктурное обязательство",
    ipOr: "ИЛИ",
    ipFullPayment: "Полная оплата в размере €1500 общей стоимости",
    limitationTitle: "7. Ограничение ответственности",
    limitationText: "DATHENT SAX S.L. не несет ответственности за:",
    thirdPartyInterruptions: "Перебои в работе сторонних сервисов",
    hostingFailures: "Сбои хостинг-провайдера",
    clientDelays: "Задержки, вызванные неполными данными от клиента",
    limitationNote: "Ответственность ограничивается стоимостью приобретенной услуги.",
    governingLawTitle: "8. Применимое право",
    governingLawText: "Настоящие Условия регулируются законодательством Испании.",
    lastUpdated: "Последнее обновление: Февраль 2026"
  },
  subscriptionPolicy: {
    title: "Соглашение о подписке",
    backToCheckout: "Назад к оформлению",
    backToHome: "Вернуться на главную",
    infraSupportTitle: "1. Поддержка инфраструктуры",
    infraSupportText: "Услуга поддержки инфраструктуры обеспечивает:",
    techStability: "Техническую стабильность",
    continuousMaintenance: "Непрерывное обслуживание",
    minorAdjustments: "Незначительные функциональные корректировки",
    monitoring: "Мониторинг и контроль производительности",
    standardRate: "Стандартная ставка: €150 в месяц.",
    discountedRateTitle: "2. Льготная ставка обязательства",
    discountedRateText: "Ставка €50/мес предоставляется исключительно в рамках модели Infrastructure Commitment.",
    minimumTerm: "Минимальный срок: 12 месяцев.",
    discountedRateNote: "Льготная ставка отражает структуру долгосрочного сотрудничества.",
    billingStructureTitle: "3. Структура биллинга",
    billing30Days: "Биллинг начинается через 30 дней после первоначального платежа за установку.",
    billingStripe: "Платежи обрабатываются безопасно через Stripe.",
    earlyExitTitle: "4. Условия досрочного выхода",
    earlyExitText: "При расторжении договора до истечения 12 месяцев оставшаяся экономическая стоимость в размере €1000 подлежит оплате.",
    earlyExitNote: "После погашения дальнейшие платежи по подписке не применяются.",
    postCommitmentTitle: "5. Фаза после обязательства",
    postCommitmentText: "После 12 месяцев соглашение продолжается на месячной основе.",
    postCommitmentNote: "Клиент может расторгнуть договор в любое время без штрафных санкций.",
    lastUpdated: "Последнее обновление: Февраль 2026"
  },
  cookies: {
    title: "Политика использования файлов cookie",
    backToCheckout: "Назад к оформлению",
    backToHome: "Вернуться на главную",
    whatAreCookiesTitle: "Что такое файлы cookie",
    whatAreCookiesText: "Файлы cookie - это небольшие текстовые файлы, которые сохраняются на вашем устройстве при посещении веб-сайта. Они помогают веб-сайту запоминать информацию о вашем посещении.",
    essentialCookiesTitle: "Обязательные файлы cookie",
    essentialCookiesText: "Этот веб-сайт использует обязательные файлы cookie, необходимые для работы.",
    essentialCookiesNote: "Эти файлы cookie необходимы для правильной работы веб-сайта и не могут быть отключены.",
    analyticsCookiesTitle: "Аналитические файлы cookie",
    analyticsCookiesText: "Аналитические файлы cookie могут использоваться для повышения производительности и понимания того, как посетители взаимодействуют с веб-сайтом.",
    analyticsCookiesNote: "Эти файлы cookie помогают нам анализировать трафик веб-сайта и оптимизировать пользовательский опыт.",
    managingCookiesTitle: "Управление файлами cookie",
    managingCookiesText: "Пользователи могут отключить необязательные файлы cookie через настройки браузера.",
    chromeSettings: "Chrome: Настройки → Конфиденциальность и безопасность → Файлы cookie",
    firefoxSettings: "Firefox: Настройки → Приватность и защита → Файлы cookie",
    safariSettings: "Safari: Настройки → Конфиденциальность → Файлы cookie",
    disablingNote: "Примечание: Отключение обязательных файлов cookie может повлиять на функциональность веб-сайта.",
    thirdPartyCookiesTitle: "Сторонние файлы cookie",
    thirdPartyCookiesText: "Мы можем использовать сторонние сервисы, которые устанавливают свои собственные файлы cookie:",
    stripeLabel: "Stripe – для обработки платежей",
    analyticsLabel: "Инструменты аналитики – для мониторинга производительности",
    updatesTitle: "Обновления этой политики",
    updatesText: "Мы можем время от времени обновлять эту Политику использования файлов cookie. Любые изменения будут опубликованы на этой странице с обновленной датой редакции.",
    contactTitle: "Контакты",
    contactText: "По вопросам об использовании нами файлов cookie, пожалуйста, свяжитесь с нами:",
    lastUpdated: "Последнее обновление: Февраль 2026"
  }
};
